<mat-card>
  <div class="p-16 fx-row align-items-center justify-content-between">
    <div class="fx-column">
      <span class="text bold dark">
        {{ 'ADMIN.ORGANIZATIONS_TITLE' | translate }}
      </span>
      <span class="text dark">
        {{ 'ADMIN.ORGANIZATIONS_BY_CLIENT_TYPE_SUBTITLE' | translate }}
      </span>
    </div>
    <button class="main-button ml-20" (click)="createOrganization()" roleBasedElement [roles]="['SUPERADMIN']">
      <div class="fx-row align-items-center justify-content-center">
        <mat-icon class="white mr-5" fontSet="material-icons-outlined">add_circle_outline</mat-icon>
        {{ 'ACTIONS.CREATE' | translate }}
      </div>
    </button>
  </div>
  <div class="p-16 fx-row align-items-center">
    <app-button-toggle class="pr-20" [buttons]="clientTypeButtons" (change)="onClientTypeChange($event)"></app-button-toggle>
    <app-input [(value)]="manager.filters.query" placeholder="{{ 'ACTIONS.SEARCH' | translate }}..." type="text"
               (change)="onQueryChange($event)"></app-input>
  </div>
  <table mat-table [dataSource]="dataSource" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class=" small light bold">
          {{'ORGANIZATION.NAME' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        <div class="fx-row align-items-center justify-content-start">
          <img [src]="organization.logo" class="org-logo mr-10" *ngIf="organization.logo" />
          <span class="main bold">{{organization.name}}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="headquartersAddress">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{'ORGANIZATION.HEADQUARTERS' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        <span class="text">{{organization.headquartersAddress}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{'ORGANIZATION.REGISTERED_SINCE' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        <span class="text">{{formatDate(organization.createdAt)}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="subscription">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{'ORGANIZATION.SUBSCRIPTION' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        <div class="fx-row align-items-center justify-content-start"
             *ngIf="!organization.subscription || !organization.subscription.plan">
          <div class="chip red">
            {{'ORGANIZATION.NO_PLAN' | translate}}</div>
        </div>

        <div *ngIf="organization.subscription && organization.subscription.plan"
             class="fx-row align-items-center justify-content-start">
          <span class="text main bold">{{organization.subscription.plan.label}}</span>
        </div>
        <div *ngIf="organization.subscription && organization.subscription.plan"
             class="fx-row align-items-center justify-content-start">
          <mat-icon class="ml-5" [class.main]="organization.subscription.additionalVolume"
                    [class.lighter]="!organization.subscription.additionalVolume" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="('ORGANIZATION.ADDITIONAL_VOLUME' | translate)+': '+(organization.subscription.additionalVolume || 0)"
                    fontSet="material-icons-outlined">description</mat-icon>
          <mat-icon class="ml-5" [class.main]="organization.subscription.additionalTrademarks"
                    [class.lighter]="!organization.subscription.additionalTrademarks" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="('ORGANIZATION.ADDITIONAL_TRADEMARKS' | translate)+': '+(organization.subscription.additionalTrademarks || 0)"
                    fontSet="material-icons-outlined">account_balance_wallet</mat-icon>
          <mat-icon class="ml-5" [class.main]="organization.subscription.additionalCases"
                    [class.lighter]="!organization.subscription.additionalCases" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="('ORGANIZATION.ADDITIONAL_CASES' | translate)+': '+(organization.subscription.additionalCases || 0)"
                    fontSet="material-icons-outlined">folder</mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="deletion">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{'ORGANIZATION.DELETION' | translate}}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        @if (organization._id && pendingDeletions.has(organization._id)) {
          <ng-container>
            <div class="fx-row align-items-center justify-content-start">
              <span class="small light mr-10">
                {{
                  'ORGANIZATION.DELETE_ORG_SCHEDULED_AT' | translate: {
                    date: formatDate(pendingDeletions.get(organization._id))
                  }
                }}
              </span>
              <span class="red clickable small p-5" role="button" (click)="cancelDeletion(organization)">
                <mat-icon>cancel</mat-icon><span class="visually-hidden">{{ 'ORGANIZATION.CANCEL_DELETE' | translate }}</span>
              </span>
            </div>
          </ng-container>
        } @else {
          <span class="text light">-</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="isSuspended">
      <th mat-header-cell *matHeaderCellDef>
        <span class=" small light bold">
          {{ 'ADMIN.ACTIVE_ORGANIZATION' | translate }}
        </span>
      </th>
      <td mat-cell *matCellDef="let organization">
        <mat-slide-toggle [ariaLabel]="'ADMIN.SUSPEND_ORGANIZATION' | translate" color="primary"
                          [checked]="!organization.isSuspended"
                          (change)="suspendOrganisation($event,organization)"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="access">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let organization">
        @if (!organization.platform) {
          <span class="access-enter-wrapper" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="(enterBlockedReason(organization) ?? '') | translate"
                [matTooltipDisabled]="!enterBlockedReason(organization)">
            <button type="button" class="button access-enter" (click)="enter(organization)"
                    [class.disabled]="!!enterBlockedReason(organization)" [disabled]="!!enterBlockedReason(organization)">
              <mat-icon class="dark mr-5" fontSet="material-icons-outlined">login</mat-icon>
              {{ 'ACCESS.ENTER' | translate }}
            </button>
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let organization" class="clickable" [routerLink]="'organizations/'+organization._id">
        <mat-icon class="main" fontSet="material-icons-outlined">keyboard_arrow_right</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let organization; columns: displayedColumns;">
    </tr>
  </table>
  <div class="p-16" *ngIf="loading">
    <span class="text light">{{'ADMIN.LIST_LOADING' | translate}}</span>
  </div>
  <div class="p-16" *ngIf="failed && !loading">
    <span class="text light">{{'ADMIN.LIST_LOADING_FAILED' | translate}}</span>
  </div>
  <div class="p-16" *ngIf="done && !loading && !failed && manager.pager.totalDocs === 0">
    <span class="text light">{{'ADMIN.SEARCH_NO_ORGANIZATIONS' | translate}}</span>
  </div>
  <mat-paginator [length]="manager.pager.totalDocs || 0" [pageSize]="manager.pager.limit || 0"
                 [pageIndex]="manager.pager.page ? (manager.pager.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
                 (page)="handlePage($event)">
  </mat-paginator>
</mat-card>
